export class GodotShader
{
  public static readonly token ="gdshader";

  public static readonly keywords:string[] = 
  [
    "shader_type","uniform","void",
    "sampler2D","vec4","vec3","vec2","float","void",
    "mat3","mat4","image2D"
  ]

  public static readonly keywords2:string[] = 
  [
    "canvas_item","spatial",
    "hint_screen_texture", 
    "repeat_disable", 
    "filter_linear_mipmap",
    "COLOR","UV","ALBEDO",
    "parameters","params","gl_GlobalInvocationID",
    "restrict","writeonly",
    "local_size_x","local_size_y","local_size_z",
    "push_constant","std430","rgba16f", "set", "binding" 
  ]
  
  
}